import { useMemo } from 'react';

import {
  DEFAULT_REPORT_CONFIG,
  normalizeConfig,
} from '@app-velocity/common';

import { useGetScopedReportConfigQuery } from '@app-velocity/libs/report';

export const useReportConfig = (workspaceId: string, prototypeId: string) => {
  const { data, isLoading } = useGetScopedReportConfigQuery(
    'FIGMA_PROTOTYPE',
    workspaceId,
    prototypeId
  );

  const { config } = useMemo(
    () => normalizeConfig(data),
    [data]
  );

  return {
    config,
    isLoading,
    DEFAULTS: DEFAULT_REPORT_CONFIG,
  };
};
